const iterableBaseUrl = process.env.ITERABLE_API_URL;

const iterableListIds = {
  blog: process.env.NEXT_PUBLIC_ITERABLE_BLOG_LIST_ID,
  partner: process.env.NEXT_PUBLIC_ITERABLE_PARTNER_LIST_ID,
};

export { iterableListIds, iterableBaseUrl };
